export default {
  TNC_ERROR: 'Pour vous connecter, vous devez d’abord accepter les conditions générales et la politique de confidentialité de Fielddrive.',
  WELCOME_BACK: 'Bienvenue à nouveau! Vous vous êtes connecté avec succès.',
  TNC_LABEL: 'en cochant cette case, vous acceptez les leads Fielddrive',
  TNC: 'Conditions générales',
  TNC_LINK: 'https://www.fielddrive.com/terms-and-conditions',
  LOWER_AND: 'et',
  POLICY: 'Politique de confidentialité',
  POLICY_LINK: 'https://www.fielddrive.com/privacy-policy',
  POLICY_LABEL: 'Vous autorisez Fielddrive Leads à traiter vos données personnelles aux fins indiquées.',
  LOGIN: 'Connexion'
}
